import { createContext, useContext } from "react";

// Width of the side nav the current layout reserves on the left - fixed-position page elements
// (e.g. the BottomBar save bar) use it to line up with the content area. Layouts whose side
// nav width differs from the default provide their own value.
const SideNavOffsetContext = createContext<string>("240px");

export const SideNavOffsetProvider = SideNavOffsetContext.Provider;

export const useSideNavOffset = () => useContext(SideNavOffsetContext);
